import React, { useState } from "react";
import { Table, Dropdown, Form, Row, Col, Pagination } from "react-bootstrap";
import { Modal, Box } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { MdKeyboardArrowDown, MdOutlineDelete } from "react-icons/md";
import { IoMdDownload } from "react-icons/io";
import { CiFileOn } from "react-icons/ci";

const data = [
  {
    img: "/assets/img/company/company-01.svg",
    id: 1,
    subscriber: "BrightWave Innovations",
    plan: "Advanced (Monthly)",
    billing: "30 Days",
    payment: "Credit Card",
    amount: 200,
    created: "12 Sep 2024",
    expiry: "11 Oct 2024",
    status: "Paid",
  },
  {
    img: "/assets/img/company/company-02.svg",

    id: 2,
    subscriber: "Stellar Dynamics",
    plan: "Basic (Yearly)",
    billing: "365 Days",
    payment: "Paypal",
    amount: 600,
    created: "23 Oct 2024",
    expiry: "23 Oct 2025",
    status: "Paid",
  },
  {
    img: "/assets/img/company/company-03.svg",

    id: 3,
    subscriber: "Quantum Nexus",
    plan: "Advanced (Monthly)",
    billing: "30 Days",
    payment: "Debit Card",
    amount: 200,
    created: "18 Feb 2024",
    expiry: "17 Mar 2024",
    status: "Paid",
  },
  {
    img: "/assets/img/company/company-04.svg",

    id: 4,
    subscriber: "EcoVision Enterprises",
    plan: "Advanced (Monthly)",
    billing: "30 Days",
    payment: "Paypal",
    amount: 200,
    created: "17 Oct 2024",
    expiry: "16 Nov 2024",
    status: "Paid",
  },
  {
    img: "/assets/img/company/company-05.svg",

    id: 5,
    subscriber: "Aurora Technologies",
    plan: "Enterprise (Monthly)",
    billing: "30 Days",
    payment: "Credit Card",
    amount: 400,
    created: "20 Jul 2024",
    expiry: "19 Aug 2024",
    status: "Paid",
  },
  {
    img: "/assets/img/company/company-14.svg",

    id: 6,
    subscriber: "BlueSky Ventures",
    plan: "Advanced (Monthly)",
    billing: "30 Days",
    payment: "Paypal",
    amount: 200,
    created: "10 Apr 2024",
    expiry: "19 Aug 2024",
    status: "Paid",
  },
  {
    img: "/assets/img/company/company-06.svg",

    id: 7,
    subscriber: "TerraFusion Energy",
    plan: "Enterprise (Yearly)",
    billing: "365 Days",
    payment: "Credit Card",
    amount: 4800,
    created: "29 Aug 2024",
    expiry: "28 Aug 2025",
    status: "Paid",
  },
  {
    img: "/assets/img/company/company-16.svg",

    id: 8,
    subscriber: "UrbanPulse Design",
    plan: "Basic (Monthly)",
    billing: "30 Days",
    payment: "Credit Card",
    amount: 50,
    created: "22 Feb 2024",
    expiry: "21 Mar 2024",
    status: "Unpaid",
  },
  {
    img: "/assets/img/company/company-17.svg",

    id: 9,
    subscriber: "Nimbus Networks",
    plan: "Basic (Yearly)",
    billing: "365 Days",
    payment: "Paypal",
    amount: 600,
    created: "03 Nov 2024",
    expiry: "02 Nov 2025",
    status: "Paid",
  },
  {
    img: "/assets/img/company/company-28.svg",

    id: 10,
    subscriber: "Epicurean Delights",
    plan: "Advanced (Monthly)",
    billing: "30 Days",
    payment: "Credit Card",
    amount: 200,
    created: "17 Dec 2024",
    expiry: "16 Jan 2025",
    status: "Paid",
  },
];


const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  backgroundColor: "#fff",
  borderRadius: "10px",
  padding: "30px",
};

function SubscriptionList() {
  const [search, setSearch] = useState("");
  const [rows, setRows] = useState(10);

  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [selected, setSelected] = useState(null);





  const filtered = data.filter((item) =>
    item.subscriber.toLowerCase().includes(search.toLowerCase()),
  );

    const [open, setOpen] = useState(false);

  // ✅ Default value like image
  const [selectedDate, setSelectedDate] = useState(
    "04/16/2026 - 04/22/2026"
  );

  const dateOptions = [
    { label: "Today", value: "04/22/2026 - 04/22/2026" },
    { label: "Yesterday", value: "04/21/2026 - 04/21/2026" },
    { label: "Last 7 Days", value: "04/16/2026 - 04/22/2026" },
    { label: "Last 30 Days", value: "03/23/2026 - 04/22/2026" },
  ];

  return (
    <div className="card p-3 mt-3">
      {/* TOP FILTER BAR */}
      <Row
        className="mb-3 align-items-center"
        style={{ borderBottom: "1px solid #dee2e6", paddingBottom: "16px" }}
      >
        <Col  style={{ display: "flex", alignItems: "center" }}>
          <h6
            style={{
              margin: 0,
              fontWeight: 600,
              color: "#0d0d0d",
              fontSize: "1.5rem",
            }}
          >
            Subscription List
          </h6>
        </Col>

        <Col  >
          <Row className="sm-mt-3 md-mt-3"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "1px", // ✅ proper spacing like design
  }}
>
  {/* DATE */}
  <Col className="mobile-respo"  xs={12} sm={6} md style={{ flex: "1" }}  >
    <div
      style={{
        position: "relative",
        height: "40px",
        width: "100%",
      }}
    >
      <div
        onClick={() => setOpen(!open)}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          background: "#fff",
          border: "1px solid #ced4da",
          borderRadius: "8px",
          cursor: "pointer",
        }}
      >
        <CalendarTodayIcon style={{ marginRight: "8px", fontSize: "18px" }} />

        <div
          style={{
            flex: 1,
            fontSize: "14px",
            fontWeight: "500",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {selectedDate}
        </div>
      </div>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "105%",
            left: 0,
            width: "100%",
            background: "#fff",
            border: "1px solid #ced4da",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 1000,
          }}
        >
          {dateOptions.map((option, idx) => (
            <div
              key={idx}
              onClick={() => {
                setSelectedDate(option.value);
                setOpen(false);
              }}
              style={{
                padding: "10px 14px",
                cursor: "pointer",
                background:
                  selectedDate === option.value
                    ? "#fd7e14"
                    : "transparent",
                color:
                  selectedDate === option.value ? "#fff" : "#212529",
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  </Col>

  {/* SELECT PLAN */}
  <Col className="mobile-respo"  xs={12} sm={6} md style={{ flex: "1" }}  >
    <select
      style={{
        width: "100%",
        height: "40px",
        padding: "0 12px",
        border: "1px solid #ced4da",
        borderRadius: "8px",
        background: "#fff",
        fontSize: "14px",
      }}
    >
      <option>Select Plan</option>
      <option>Advanced (Monthly)</option>
      <option>Basic (Yearly)</option>
    </select>
  </Col>

  {/* STATUS */}
  <Col  className="mobile-respo" xs={12} sm={6} md style={{ flex: "1" }}>
    <select
      style={{
        width: "100%",
        height: "40px",
        padding: "0 12px",
        border: "1px solid #ced4da",
        borderRadius: "8px",
        background: "#fff",
        fontSize: "14px",
      }}
    >
      <option>Select Status</option>
      <option>Paid</option>
      <option>Pending</option>
    </select>
  </Col>

  {/* SORT */}
  <Col  className="mobile-respo" xs={12} sm={6} md style={{ flex: "1" }}>
    <select
      style={{
        width: "100%",
        height: "40px",
        padding: "0 12px",
        border: "1px solid #ced4da",
        borderRadius: "8px",
        background: "#fff",
        fontSize: "14px",
      }}
    >
      <option>Sort By : Last 7 Days</option>
      <option>Last 30 Days</option>
    </select>
  </Col>
</Row>
        </Col>
      </Row>

      {/* HEADER */}

      <Row className="mb-2">
        <Col md={6}>
          <div className="d-flex align-items-center">
            <span className="me-2">Row Per Page</span>

            <Form.Select
              style={{ width: "80px" }}
              value={rows}
              onChange={(e) => setRows(e.target.value)}
            >
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </Form.Select>

            <span className="ms-2">Entries</span>
          </div>
        </Col>

        <Col md={6} className="text-end">
          <Form.Control
            placeholder="Search"
            style={{ width: "200px", display: "inline" }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
      </Row>

      {/* TABLE */}

      <Table responsive hover>
        <thead className="table-light">
          <tr>
            <th></th>
            <th>Subscriber</th>
            <th>Plan</th>
            <th>Billing Cycle</th>
            <th>Payment Method</th>
            <th>Amount</th>
            <th>Created Date</th>
            <th>Expiring On</th>
            <th>Status</th>

            <th
              style={{
                width: "130px",
                textAlign: "center",
              }}
            >
              Action
            </th>
          </tr>
        </thead>

        <tbody>
          {filtered.slice(0, rows).map((item) => (
            <tr
              key={item.id}
              style={{
                verticalAlign: "middle",
              }}
            >
              {/* CHECKBOX */}
              <td>
                <input type="checkbox" />
              </td>

              {/* SUBSCRIBER IMAGE */}
              <td>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <img
                    src={item.img}
                    alt=""
                    style={{
                      width: "28px",
                      height: "28px",
                      borderRadius: "50%",
                      border: "1px solid #eee",
                      objectFit: "cover",
                    }}
                  />

                  <span
                    style={{
                      fontWeight: "500",
                    }}
                  >
                    {item.subscriber}
                  </span>
                </div>
              </td>

              {/* PLAN */}
              <td>{item.plan}</td>

              {/* BILLING */}
              <td>{item.billing}</td>

              {/* PAYMENT */}
              <td>{item.payment}</td>

              {/* AMOUNT */}
              <td>${item.amount}</td>

              {/* CREATED */}
              <td>{item.created}</td>

              {/* EXPIRY */}
              <td>{item.expiry}</td>

              {/* STATUS */}
              <td>
                <span
                  style={{
                    padding: "5px 10px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#fff",
                    backgroundColor:
                      item.status === "Paid" ? "#22c55e" : "#ef4444",
                  }}
                >
                  {item.status}
                </span>
              </td>

              {/* ACTION ICONS */}
              <td
                style={{
                  minWidth: "130px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "14px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {/* VIEW INVOICE */}
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#6b7280",
                    }}
                    onClick={() => {
                      setSelected(item);
                      setInvoiceOpen(true);
                    }}
                  >
                    <CiFileOn />
                  </span>

                  {/* DOWNLOAD */}
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#6b7280",
                    }}
                    onClick={() => {
                      const blob = new Blob(["invoice"]);
                      const link = document.createElement("a");
                      link.href = URL.createObjectURL(blob);
                      link.download = "invoice.txt";
                      link.click();
                    }}
                  >
                    <IoMdDownload />
                  </span>

                  {/* DELETE */}
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#6b7280",
                    }}
                    onClick={() => {
                      setSelected(item);
                      setDeleteOpen(true);
                    }}
                  >
                    <MdOutlineDelete />
                  </span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* PAGINATION */}
{/* 
      <div className="d-flex justify-content-between">
        <span>
          Showing 1 - {rows} of {data.length} entries
        </span>

        <Pagination>
          <Pagination.Prev />

          <Pagination.Item active>1</Pagination.Item>

          <Pagination.Next />
        </Pagination>
      </div> */}

      {/* INVOICE MODAL */}

      <Modal open={invoiceOpen} onClose={() => setInvoiceOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95%", md: "900px" },
            bgcolor: "#fff",
            borderRadius: "8px",
            boxShadow: 24,
            p: { xs: 2, md: 4 },
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          {/* HEADER */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start mb-4">
            <div className="mb-3 mb-md-0">
              <img
                src="/assets/img/logo-1.svg"
                alt="logo"
                style={{ height: "40px" }}
              />
            </div>

            <div className="text-md-end">
              <h5 className="fw-bold mb-1">Invoice</h5>
              <p className="mb-1">
                <i className="ti ti-file-invoice me-1"></i>INV0287
              </p>
              <p className="mb-1">
                <i className="ti ti-calendar me-1"></i>Issue date :{" "}
                {selected?.created}
              </p>
              <p>
                <i className="ti ti-calendar me-1"></i>Due date :{" "}
                {selected?.expiry}
              </p>
            </div>
          </div>

          {/* INVOICE ADDRESS */}
          <div className="row mb-4">
            <div className="col-md-6 mb-3">
              <p className="fw-semibold mb-2">Invoice From :</p>
              <p className="mb-1">SmartHR</p>
              <p className="mb-1">
                367 Hillcrest Lane, Irvine, California, United States
              </p>
              <p className="mb-1">[email protected]</p>
            </div>

            <div className="col-md-6">
              <p className="fw-semibold mb-2">Invoice To :</p>
              <p className="mb-1">{selected?.subscriber}</p>
              <p className="mb-1">
                367 Hillcrest Lane, Irvine, California, United States
              </p>
              <p className="mb-1">[email protected]</p>
            </div>
          </div>

          {/* TABLE */}
          <div className="table-responsive mb-4">
            <table className="table align-middle">
              <thead style={{ background: "#f3f3f3" }}>
                <tr>
                  <th>Plan</th>
                  <th>Billing Cycle</th>
                  <th>Created Date</th>
                  <th>Expiring On</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{selected?.plan}</td>
                  <td>{selected?.billing}</td>
                  <td>{selected?.created}</td>
                  <td>{selected?.expiry}</td>
                  <td>${selected?.amount}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* PAYMENT INFO */}
          <div className="row mb-4">
            <div className="col-md-6 mb-3">
              <h6 className="fw-semibold mb-3">Payment info:</h6>

              <p className="mb-1">Credit Card - 123***********789</p>

              <div className="d-flex justify-content-between">
                <span>Amount</span>
                <span className="fw-semibold">${selected?.amount}.00</span>
              </div>
            </div>

            <div className="col-md-6">
              <div className="d-flex justify-content-between mb-2">
                <span className="fw-semibold">Sub Total</span>
                <span>${selected?.amount}.00</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span className="fw-semibold">Tax</span>
                <span>$0.00</span>
              </div>

              <div className="d-flex justify-content-between">
                <span className="fw-semibold">Total</span>
                <span className="fw-semibold">${selected?.amount}.00</span>
              </div>
            </div>
          </div>

          {/* TERMS */}
          <div
            style={{
              border: "1px solid #e5e5e5",
              borderRadius: "8px",
              padding: "16px",
              background: "#fafafa",
            }}
          >
            <p className="fw-semibold mb-2">Terms & Conditions:</p>

            <p className="mb-2 small">
              <span style={{ color: "#ff6a00" }}>•</span> All payments must be
              made according to the agreed schedule. Late payments may incur
              additional fees.
            </p>

            <p className="small mb-0">
              <span style={{ color: "#ff6a00" }}>•</span> We are not liable for
              any indirect, incidental, or consequential damages, including loss
              of profits, revenue, or data.
            </p>
          </div>
        </Box>
      </Modal>

      {/* DELETE MODAL */}

      <Modal open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <Box className="border border-3"
          sx={{
            ...modalStyle,
            width: 400,
            textAlign: "center",
          }}
        >
          <h4>Confirm Delete</h4>

          <p>
            You want to delete all the marked items, this cant be undone once
            you delete.
          </p>

          <button
            className="btn btn-light border border-1 me-2"
            onClick={() => setDeleteOpen(false)}
          >
            Cancel
          </button>

          <button
            className="btn btn-danger"
            onClick={() => setDeleteOpen(false)}
          >
            Yes Delete
          </button>
        </Box>
      </Modal>
      <style>
        {
          `
@media(min-width: 992px){
        .mobile-respo{
        magin-top:10px !important;
        }
        }
@media(max-width:576px){
  .mobile-respo{
    margin-top:10px !important;
  }
}
 @media(max-width:768px){
  .mobile-respo{
    margin-top:10px !important;
  }
}

          `
        }
      </style>
    </div>
  );
}

export default SubscriptionList;
